import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Switch,
  Tab,
  Tabs,
} from '@mui/material';
import CardDTO from '@src/adapters/dto/card/CardDTO';
import { useState } from 'react';
import ConsultantName from '../../user/ConsultantName';
import ProcedureName from '../../procedure/ProcedureName';
import CardTab from './CardTab';
import CloseIcon from '@mui/icons-material/Close';
import useRejectCardVersionLazy from '@src/adapters/hooks/card/useRejectCardVersion';
import useApproveCardVersionLazy from '@src/adapters/hooks/card/useApproveCardVersion';
interface Props {
  card: CardDTO;
  open: boolean;
  showApprove?: boolean;
  onClose(): void;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function CardPreviewDialog({ card, open, showApprove, onClose }: Props) {
  const [selectedTab, setSelectedTab] = useState(0);
  const [isShowChanges, setIsShowChanges] = useState(false);
  const { execute: reject } = useRejectCardVersionLazy();
  const { execute: approve } = useApproveCardVersionLazy();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  const handleClose = () => {
    setIsShowChanges(false);
    onClose();
  };

  const handleRejectAll = async () => {
    await reject({ cardId: card.id });
    onClose();
  };

  const handleApprove = async () => {
    await approve({ cardId: card.id });
    onClose();
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="Preview"
      fullScreen
      sx={{ margin: '20px' }}>
      <DialogTitle
        id="alert-dialog-title"
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(2),
          justifyContent: 'space-between',
        })}>
        <Box>
          <ConsultantName id={card.consultantId} /> -{' '}
          <ProcedureName id={card.procedureId} />{' '}
        </Box>
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          aria-label="Card Sections">
          <Tab label="Card" {...a11yProps(0)} />
          {/* <Tab label="Notes" {...a11yProps(1)} />
          <Tab label="Attachments" {...a11yProps(2)} /> */}
        </Tabs>
        <Box>
          {showApprove && (
            <Button
              onClick={handleRejectAll}
              color="error"
              variant="outlined"
              sx={{ flex: '1', marginRight: '8px' }}>
              Reject All
            </Button>
          )}
          {showApprove && (
            <Button
              onClick={handleApprove}
              color="primary"
              variant="contained"
              sx={{ flex: '1', marginRight: '8px' }}>
              Approve
            </Button>
          )}
          <FormControlLabel
            control={
              <Switch
                checked={isShowChanges}
                onChange={() => setIsShowChanges(!isShowChanges)}
              />
            }
            label={isShowChanges ? 'Hide changes' : 'Show changes'}
          />
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleClose}
            edge="start"
            sx={(theme) => ({
              marginRight: theme.spacing(2),
              color: 'rgba(1, 4, 13, 0.5)',
              height: '44px',
              marginLeft: theme.spacing(2),
            })}
            size="large">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: 'rgb(244,249,253)' }}>
        <CustomTabPanel value={selectedTab} index={0}>
          <CardTab card={card} isShowChanges={isShowChanges} />
        </CustomTabPanel>
      </DialogContent>
    </Dialog>
  );
}

export default CardPreviewDialog;
